import * as React from "react";
import { format, parseISO } from 'date-fns'
import {makeStyles} from "@material-ui/styles";
import mock from "../mock.json";
import Operadores from "./Operadores";
import PaginaA4 from "../../../../components/reports/paginaA4";
import NotasPag from "./NotasPag";



const useStyles = makeStyles(theme => ({



}));

const Pagina4 = (props) => {
    const classes = useStyles();

    const raspaReportData = props.raspaReportData? props.raspaReportData : mock;

    return (
        <PaginaA4
            titulo={'PRODUTIVIDADE RASPAROBO LUKATEC'}
            subtitulo={`PERIODO ${format(parseISO(raspaReportData.periodo.periodo.periodoIni),'dd/MM/yyyy')} A ${format(parseISO(raspaReportData.periodo.periodo.periodoFim),'dd/MM/yyyy')}`}
            areaCima={<React.Fragment>
                <Operadores raspaReportData={raspaReportData}/>
            </React.Fragment>}
            areaBaixo={<NotasPag/>}
            rodape={``}
            pagina={4}
        />
    )
}


export default  Pagina4;